import { useCookies } from "react-cookie";
// import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import http from "../common/http-common";
import CssClass from "../Styles/common.module.css";
import * as common from "../common/common";
import * as Comp from "../common/CommonComponents";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Email_Unread_Icon from '../assets/Email_Unread_Icon.png';
import Tooltip from '@mui/material/Tooltip';

const PAGE_NAME = "Home.js_";

const Home = () => {
  document.title =  common.c_TITLE + " - Home" ;

  // const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  //VIEW ALL TICKET AT HOMEPAGE
  //const [viewData, setViewData] = useState('OWN');
  const [viewData, setViewData] = useState('ALL');

  const [allData, setAllData] = useState([]);
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const [orgCategory, setOrgCategory] = useState("");

  useEffect(() => {
    let functionName = "";

    try {
      functionName = "Get Orginazation Category";
      onLoadingHandler(true, "Getting Orginazation Category, please wait...");

      var listItems = [];
      http
        .get(
          `api/ticket/GetOrgCategory?_user=${userId}`,
          { timeout: 100000 }
        )
        .then((response) => {
          setOrgCategory(response.data[0].ORG_CATEGORY_NAME);
        })
        .catch((err) => {
          toast.error("Error on Getting Orginazation Category.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");
        });
    } catch (err) {
      toast.error("Error on Getting Orginazation Category.");
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }, [userId]);

  //#region Toggle
  const handleChange = (event, newView) => {
    setViewData(newView);
    setReload(!reload);
  };

  useEffect(() => {
    let functionName = "";

    try {
      functionName = "Get All Tickets";

      onLoadingHandler(true, "Getting Tickets, please wait...");

      setAllData([]);

      const userIdFilter =
        viewData === "ALL"
            ? ""
            : userId;

      const listItems = [];         
  
      http
        .get(
          "api/ticket/GetHomeTickets?_user=" + userId + "&_userIdFilter=" + userIdFilter,
          { timeout: 10000000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              listItems.push({
                key: counter,
                TICKET_MST_ID: data.TICKET_MST_ID,
                TICKET_NUM: data.TICKET_NUM,
                ORG_ID: data.ORG_ID,
                ORG_NAME: data.ORG_NAME,
                SYSTEM_MST_ID: data.SYSTEM_MST_ID,
                SYSTEM_MST_NAME: data.SYSTEM_MST_NAME,
                SUBJECT: data.SUBJECT,
                TICKET_DETAILS: data.TICKET_DETAILS,
                CREATE_BY: data.CREATE_BY,
                CREATE_NAME: data.CREATE_NAME,
                CREATE_DATETIME: data.CREATE_DATETIME,
                TICKET_CATEGORY_ID: data.TICKET_CATEGORY_ID,
                TICKET_CATEGORY_NAME: data.TICKET_CATEGORY_NAME,
                TICKET_PRIORITY_TYPE_ID: data.TICKET_PRIORITY_TYPE_ID,
                TICKET_PRIORITY_TYPE_NAME: data.TICKET_PRIORITY_TYPE_NAME,
                TICKET_STATUS_TYPE_ID: data.TICKET_STATUS_TYPE_ID,
                TICKET_STATUS_TYPE_NAME: data.TICKET_STATUS_TYPE_NAME,
                ACKNOWLEDGED_BY: data.ACKNOWLEDGED_BY,
                ACKNOWLEDGED_NAME: data.ACKNOWLEDGED_NAME,
                TARGET_MANDAYS: data.TARGET_MANDAYS,
                TOTAL_COMPLETE_TIME: data.TOTAL_COMPLETE_TIME,
                LEAD_TIME: data.LEAD_TIME,
                ATTACHMENT_ID: data.ATTACHMENT_ID,
                INTERNAL_NOTE: data.INTERNAL_NOTE,
                STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                UPDATE_ID: data.UPDATE_ID,
                UPDATE_NAME: data.UPDATE_NAME,
                UPDATE_DATETIME: data.UPDATE_DATETIME,
                READ_FLAG: data.READ_FLAG,
                READ_BY: data.READ_BY,
              });
            });
          }
          setAllData(listItems);
        })
        .catch((err) => {
          toast.error("Error on getting ticket list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");   
        });    
    } catch (err) {
      toast.error("Error on getting ticket list. Please try again.");
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }, [reload, userId, viewData])

  const columns = [
    {
      accessorKey: "CREATE_DATETIME",
      header: "Created Datetime",
      Cell: ({ cell }) =>
        cell.getValue() === "0001-01-01T00:00:00"
          ? "-"
          : moment(cell.getValue()).format("DD/MM/YYYY hh:mm A"),
    },
    {
      accessorKey: "CREATE_NAME",
      header: "Created By",
      size: 60,
    },
    // {
    //   accessorKey: "ORG_NAME",
    //   header: "Company",
    //   size: 40,
    // },
    {
      accessorKey: "SYSTEM_MST_NAME",
      header: "System",
      size: 60,
    },
    {
      id: "ticketNo",
      header: "Ticket #",
      size: 60,
      accessorFn: (row) => (
        `${row.TICKET_NUM} ${row.TICKET_MST_ID}`,
        <div>
          <span>
            <Comp.Button
              id="btnView"
              type="general"
              size="xl"
              onClick={(e) => onTicketDetailsHandler(e, row)}
            >
              {row.TICKET_NUM}
            </Comp.Button>
            {row.READ_FLAG === 'N' && row.READ_BY === userId && (
              <img
                  src={Email_Unread_Icon}
                  alt={""}
                  style={{height: '30px', width: '30px'}}
              />
            )}
          </span>
        </div>
      )
    },
    {
      id: "TICKET_STATUS_TYPE_NAME",
      header: "Status",
      size: 100,
      accessorFn: (row) => {
        var className;
        switch(row.TICKET_STATUS_TYPE_NAME) {
          case "OPEN": 
            className = CssClass.openStatus;
            break;
          case "ACKNOWLEDGE":
            className = CssClass.ackStatus;
            break;
          case "CLOSED":
            className = CssClass.closeStatus;
            break;
          case "CANCEL":
            className = CssClass.cancelStatus;
            break;
          case "RESOLVED":
            className = CssClass.resolvedStatus;
            break;
          case "VERIFIED":
            className = CssClass.verifiedStatus;
            break;
          default :
            className = "";
        }
        return <span className={className}>{row.TICKET_STATUS_TYPE_NAME}</span>;
      }
    },
    {
      accessorKey: "SUBJECT",
      header: "Title",
      size: 300,
      Cell: ({ cell }) => {
        const [isExpanded, setIsExpanded] = useState(false);
        const text = cell.getValue();
        const maxLength = 100;
        // Toggle expand/collapse
        const toggleExpand = () => {
          setIsExpanded(prevState => !prevState);
        };
    
        return (
          <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {text?.length > maxLength ? (
              <>
                {/* Show either truncated or full text based on state */}
                {isExpanded ? text : text.substring(0, maxLength) + "..."} 
                &nbsp;
                {/* Toggle button */}
                <a 
                  onClick={toggleExpand}
                  style={{ 
                    color: '#007bff', 
                    cursor: 'pointer', 
                    textDecoration: 'none',
                    fontWeight: 'bold' 
                  }}
                  onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                  onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                  >
                    {isExpanded ? "Show less" : "Read more"}
                </a>
              </>
            ) : (
              text
            )}
          </div>
        );
      },
    },
    {
      accessorKey: "ACKNOWLEDGED_NAME",
      header: "Assigned To",
    },
    {
      accessorKey: "LEAD_TIME",
      header: "Lead Time",
      size: 120,
      Cell: ({ cell }) => {
        const val = cell.getValue();
        if (!val || val === "-") return "-";
        const parts = String(val).split(':'); // expected D:HH:MM
        let days = '0', hours = '00', mins = '00';
        if (parts.length >= 3) {
          days = parts[0];
          hours = String(parts[1]).padStart(2, '0');
          mins = String(parts[2]).padStart(2, '0');
        } else if (parts.length === 2) {
          hours = String(parts[0]).padStart(2, '0');
          mins = String(parts[1]).padStart(2, '0');
        } else {
          return val; // fallback
        }
        // return <span>{`${days}d ${hours}h ${mins}m`}</span>;
        const tooltipText = "Acknowledge - Closed";
        return (
          <Tooltip title={tooltipText} arrow>
            <span style={{ display: 'inline-block', cursor: 'default' }}>
              {`${days}d ${hours}h ${mins}m`}
            </span>
          </Tooltip>
        );
      },
    },
    // {
    //   accessorKey: "TARGET_MANDAYS",
    //   header: "Target Mandays",
    // },
    // {
    //   accessorKey: "TOTAL_COMPLETE_TIME",
    //   header: "Required Mandays",
    // },
    // {
    //   accessorKey: "LEAD_TIME",
    //   header: "Lead Time (day)",
    //   size: 40,
    // },
    // {
    //   accessorKey: "UPDATE_DATETIME",
    //   header: "Update By",
    //   Cell: ({ cell }) =>
    //     cell.getValue() === "0001-01-01T00:00:00"
    //       ? "-"
    //       : moment(cell.getValue()).format("DD/MM/YYYY hh:mm A"),
    // },
    // {
    //   accessorKey: "UPDATE_NAME",
    //   header: "Update By",
    //   size: 60,
    // },
  ];

  const onTicketDetailsHandler = (e, row) => {
    let functionName = "onTicketDetailsHandler";

    try {
      functionName = onTicketDetailsHandler.name;

      window.open("ViewTicket?_ticketNo=" + row.TICKET_NUM + "&_id=" + row.TICKET_MST_ID)
      // var newWindow = window.open("ViewTicket?_ticketNo=" + row.TICKET_NUM /*+ "&_id=" + row.TICKET_MST_ID*/)
      // newWindow["TICKET_MST_ID"] = row.TICKET_MST_ID;

    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const statusCounts = allData.reduce((acc, ticket) => {
    acc[ticket.TICKET_STATUS_TYPE_NAME] = (acc[ticket.TICKET_STATUS_TYPE_NAME] || 0) + 1;
    return acc;
  }, {});  

  const visibleColumns = columns.filter(col => {
    if (col.accessorKey === "LEAD_TIME" && orgCategory !== "INTERNAL") {
      return false; // hide if not INTERNAL
    }
    return true;
  });

  return(
    <>
      
      <div style={{width: "100%", float: "left"}}>
        <div style={{width: "100%", padding: "13px"}}>
          {orgCategory === "INTERNAL" && (
            <ToggleButtonGroup
            style={{float: "left", padding: "1px"}}
            color="primary"
            value={viewData}
            exclusive
            onReload={onReloadHandler}
            onChange={handleChange}
            aria-label="Platform"
          >
              <ToggleButton value="ALL" className={viewData === "ALL" ? CssClass.toggleButtonSelected : ""}>All Ticket</ToggleButton>
              <ToggleButton value="OWN" className={viewData === "OWN" ? CssClass.toggleButtonSelected : ""}>My Ticket</ToggleButton>
            </ToggleButtonGroup>
          )}
            <div style={{ float: "right", display: "flex", gap: "5px" }}>
              <div style={{ backgroundColor: "#d9534f", color: "white", width: "120px", textAlign: "center", padding: "10px 20px", borderRadius: "5px", fontSize: "16px" }}>OPEN
                <div style={{ fontSize: "18px", fontWeight: "bold", marginTop: "1px" }}>{statusCounts["OPEN"] || 0}</div>
              </div>
              <div style={{ backgroundColor: "#ffd700", color: "white", width: "120px", textAlign: "center", padding: "10px 20px", borderRadius: "5px", fontSize: "16px" }}>ACK
                <div style={{ fontSize: "18px", fontWeight: "bold", marginTop: "1px" }}>{statusCounts["ACKNOWLEDGE"] || 0}</div>
              </div>
              <div style={{ backgroundColor: "#0066cc", color: "white", width: "120px", textAlign: "center", padding: "10px 20px", borderRadius: "5px", fontSize: "16px" }}>RESOLVED
                <div style={{ fontSize: "18px", fontWeight: "bold", marginTop: "1px" }}>{statusCounts["RESOLVED"] || 0}</div>
              </div>
              <div style={{ backgroundColor: "#6f42c1", color: "white", width: "120px", textAlign: "center", padding: "10px 20px", borderRadius: "5px", fontSize: "16px" }}>VERIFIED
                <div style={{ fontSize: "18px", fontWeight: "bold", marginTop: "1px" }}>{statusCounts["VERIFIED"] || 0}</div>
              </div>
            </div>
        </div>
      </div>
      
      <div className={`${CssClass.homeCard} ${CssClass.tableCard}`}>
        <div style={{ width: "100%"}}>
          <Comp.HomeTable 
            data={allData} 
            // columns={columns} 
            columns={visibleColumns}
            onReload={onReloadHandler}
            onLoading={onLoadingHandler}
            height={"75vh"}
            width={"100%"}
            enableRowSelection={false}
            enableStickyHeader={true}   
            enableTopToolbar      
          />
        </div>
      </div>
      
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
    
  );
}
export default Home;
